import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const addComment = createAsyncThunk(
  'comments/addComment',
  async ({ product_id, comment, rating }, { rejectWithValue }) => {
    try {
      const tokenData = JSON.parse(localStorage.getItem('userTools'));
      const token = tokenData?.token;
      if (!token || token === 'social_login_placeholder') {
        return rejectWithValue({ message: 'You must be logged in to comment.' });
      }
      const body = { product_id, comment };
      if (typeof rating !== 'undefined') body.rating = rating;
      const response = await axios.post(
        `${BASE_URL}/comments`,
        body,
        {
          headers: {
            Authorization: `Bearer ${token.token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: 'Failed to add comment' });
    }
  }
); 